import { render, staticRenderFns } from "./AclsGroups.vue?vue&type=template&id=c1206fc4"
import script from "./AclsGroups.vue?vue&type=script&lang=js"
export * from "./AclsGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports